import React, { useState, useEffect } from 'react'
import classes from '../../components/utils/form/SecondaryGrid.module.css';
import moment from 'moment';
// assets
import reload from '../../assets/icons/actualizar.svg'
// components
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Buttons from '../../components/utils/buttonsContainer/Buttons';
import HeaderButton from '../../components/utils/button/HeaderButton';
import ServerPaginationGrid from '../../components/utils/grid/PaginatedGrid';
// const
import { movimientos as titles } from '../../consts/titulos-de-tablas';
// services
import { MWMovimientoGet } from '../../services/hooli-services';
// recoil 
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { userCredentials, rowSelected, formIsOpen } from '../../recoilState/GlobalState';
import * as XLSX from "xlsx";

export default function ModalMovimientos({ props, date }) {
    const [movimientos, setMovimientos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const { row } = useRecoilValue(rowSelected);
    const [rowsExport, setRowsExport] = useState([])
    const credentials = useRecoilValue(userCredentials);
    const setFormOpen = useSetRecoilState(formIsOpen);
    const [pageTemp, setPageTemp] = useState({page: 0, pageLen: 0})

    const { moneda } = props || "ARS";
    const handleExport = () => {
        const rowsFilter = rowsExport.map((e) => ({
          [titles[0]]: e[titles[0]],
          [titles[1]]: e[titles[1]],
          [titles[2]]: e[titles[2]],
          [titles[3]]: e[titles[3]],
          [titles[4]]: e[titles[4]],
          [titles[5]]: e[titles[5]],
          [titles[6]]: e[titles[6]],
          [titles[7]]: e[titles[7]],
          [titles[8]]: e[titles[8]],
        }));
        const worksheet = XLSX.utils.json_to_sheet(rowsFilter);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `movimientos_cuenta_${date}.xlsx`, { compression: true });
      };

    async function retrieveMovimientos(page, pageLen) {
        setPageTemp({page, pageLen})
        const payload = {
            ...credentials,
            "merchantId": credentials.merchantId,
            "monedaCod": moneda,
            "fecha": row.id,
            "page": page + 1,
            "pageLen": pageLen
        };
        setCargando(true);
        const data = await MWMovimientoGet(payload);
        setCargando(false);
        setRowsExport(data.movimientos.map(( item, index) => {
                return {
                    id: index,
                    [titles[0]]: item.movimientoFecha.substring(11),
                    [titles[1]]: item.tipoMovimientoNombre,
                    [titles[2]]: item.movimientoDebito,
                    [titles[3]]: item.movimientoCredito,
                    [titles[4]]: item.saldoParcial,
                    [titles[5]]: item.movimientoOrigenDestino,
                    [titles[6]]: item.movimientoReferencia,
                    [titles[7]]: `${item.movimientoConcepto} ${item.movimientoComprobante}`,
                    [titles[8]]: item.movimientoTransaccionUUID,
                }
            }))
        return {
            rows: data.movimientos.map(( item, index) => {
                return {
                    id: index,
                    [titles[0]]: item.movimientoFecha.substring(11),
                    [titles[1]]: item.tipoMovimientoNombre,
                    [titles[2]]: item.movimientoDebito,
                    [titles[3]]: item.movimientoCredito,
                    [titles[4]]: item.saldoParcial,
                    [titles[5]]: item.movimientoOrigenDestino,
                    [titles[6]]: item.movimientoReferencia,
                    [titles[7]]: `${item.movimientoConcepto} ${item.movimientoComprobante}`,
                    [titles[8]]: item.movimientoTransaccionUUID,
                }
            }),
            rowCount: data.totalDeMovimientos
        };
    };

    return (
        <div className={classes.container}>
            <Buttons>
                <HeaderButton
                    text={"Actualizar pagina"}
                    icon={reload}
                    updateList={() => retrieveMovimientos(pageTemp.page, pageTemp.pageLen)}
                />
                <HeaderButton
                    text={"Descargar tabla"}
                    // icon={CloudDownloadIcon}
                    handleClick={handleExport}
                >
                    <CloudDownloadIcon/>
                </HeaderButton>
            </Buttons>
            <div className={classes.gridContainer} >
                <ServerPaginationGrid
                    titles={titles}
                    route='/saldos'
                    updateList={retrieveMovimientos}
                    isLoading={cargando}
                    selectedActive = {false}
                />
            </div>
        </div>
    )
}